module.exports = __webpack_public_path__ + "static/media/tamarnetergans.fe5ae556.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/tamarnetergans.webp
// module id = 378
// module chunks = 0